import { Middleware } from '@reduxjs/toolkit'
import { io, Socket } from 'socket.io-client'

import { slice as authSlice } from './auth'
import { slice as ordersSlice } from './orders'

// В socket.io путь в URL — это namespace, а не часть адреса. Гейтвей namespace
// не объявляет, поэтому существует только '/', и с хвостом '/api' подключение
// падало с «Invalid namespace». Адрес сервера берём без него, а /api уходит в path.
const WS_URL = import.meta.env.VITE_BASE_URL
  ?.replace(/\/api\/?$/, '')
  .replace('https://', 'wss://')
  .replace('http://', 'ws://')

let connection: Socket | null = null

export const socketMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action)

  // Connect socket on login
  if (authSlice.actions.loginSuccess.match(action)) {
    if (!connection) {
      connection = io(WS_URL, {
        path: '/api/pusher',
        transports: ['websocket', 'polling'],
        autoConnect: false,
      })

      connection.on('action', (event: { type: string; data: any }) => {
        if (event.type === 'SOCKET/CONNECTED') {
          const { user } = store.getState().auth
          if (user?.outlet) {
            connection!.emit('setUser', user.outlet)
          } else {
            // User not loaded yet, retry after a short delay
            setTimeout(() => {
              const { user } = store.getState().auth
              if (user?.outlet && connection) {
                connection.emit('setUser', user.outlet)
              }
            }, 1000)
          }
        }

        if (event.type === 'SOCKET/NEW_ORDER') {
          store.dispatch(ordersSlice.actions.addNewOrder(event.data))
        }
      })

      connection.connect()
    }
  }

  // Disconnect socket on logout and reset orders
  if (authSlice.actions.reset.match(action)) {
    if (connection) {
      connection.disconnect()
      connection = null
    }
    store.dispatch(ordersSlice.actions.reset())
  }

  return result
}
